import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation UpdateFormAdjustmentDefinition(
    $organizationId: Int!
    $id: Int!
    $amount: Int
    $maxAmount: Int
    $name: String
  ) {
    updateFormAdjustmentDefinition(
      organizationId: $organizationId
      id: $id
      input: { amount: $amount, maxAmount: $maxAmount, name: $name }
    ) {
      id
      active
      name
      category
      amount
      name
    }
  }
`;
